import React from "react";
import Products from "../components/Products/Products";

export default function AllProducts() {
  return (
    <>
      <Products />
    </>
  );
}
